webpackJsonp([1],{

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_socket_io__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_socket_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_observe_visibility__ = __webpack_require__(154);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_observe_visibility__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_socket_io___default.a, 'https://odc.tennis-score.ovh');
// Vue.use(VueSocketIO, 'http://odc-backend-dev.eu-west-3.elasticbeanstalk.com/')
// Vue.use(VueSocketIO, 'http://localhost:8080')

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value).format('DD-MM-YYYY');
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f67923a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(129);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f67923a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Default__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pds__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Live__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Zenith__ = __webpack_require__(147);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Default',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Default__["a" /* default */]
  }, {
    path: '/zenith',
    name: 'Zenith',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Zenith__["a" /* default */]
  }, {
    path: '/pds',
    name: 'Pds',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Pds__["a" /* default */]
  }, {
    path: '/live',
    name: 'Live',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Live__["a" /* default */]
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Default__["a" /* default */]
  }]
}));

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fffc62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__ = __webpack_require__(138);
function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fffc62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 133:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      matchList: undefined,
      playerList: undefined,
      currentMatch: undefined,
      stats: undefined,
      sponsorList: [{
        'name': 'villaeugene',
        'logo': 'villaeugene2.png',
        'link': 'http://villa-eugene.fr/'
      }, {
        'name': 'fgprod',
        'logo': 'fgprod.png',
        'link': 'http://www.fg-productions.tv/'
      }, {
        'name': 'jurzak',
        'logo': 'jurzak2.png',
        'link': 'http://www.jurzak-constructions.com/'
      }, {
        'name': 'leclerc',
        'logo': 'leclerc.png',
        'link': 'http://www.e-leclerc.com/caen'
      }, {
        'name': 'legallais',
        'logo': 'legallais.png',
        'link': 'https://www.legallais.com/'
      }]
    };
  },
  created: function created() {
    this.$socket.emit('getPlayers');
    this.$socket.emit('getMatchs');
    this.$socket.emit('getCurrentMatch');
  },

  sockets: {
    matchs: function matchs(data) {
      if (data) {
        this.matchList = data;
      }
    },
    displayMatch: function displayMatch(data) {
      if (data) {
        this.currentMatch = data;
      }
    },
    players: function players(data) {
      if (data) {
        this.playerList = data;
      }
    },
    stats: function stats(data) {
      if (data) {
        console.log('receive stat' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        this.stats = data;
      }
    }
  },
  methods: {
    reloadMatch: function reloadMatch() {
      this.$socket.emit('getMatchs');
    },
    showStats: function showStats(matchId) {
      console.log('request stat' + matchId);
      this.$socket.emit('getStats', matchId);
    },
    getTotalDuration: function getTotalDuration(startDate, endDate, currentDate) {
      if (startDate) {
        var sDate = new Date(startDate);
        var eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date();
        var duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000);
        if (duration < 0) {
          duration = 0;
        }
        var hours = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - hours * 3600) / 60);

        if (minutes < 10) {
          minutes = '0' + minutes;
        }
        return hours + ':' + minutes;
      } else {
        return "0'";
      }
    },
    getDuration: function getDuration(startDate, endDate, currentDate) {
      if (startDate) {
        var sDate = new Date(startDate);
        var eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date();
        var duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000);
        if (duration < 0) {
          duration = 0;
        }
        var hours = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - hours * 3600) / 60) + hours * 60;

        return minutes + "'";
      } else {
        return "0'";
      }
    },
    getFlag: function getFlag(match, playerIndex) {
      if (!match || !match.flags) {
        return '';
      }
      if (match.flags.winnerId === playerIndex) {
        return 'flagWinner';
      } else if (match.flags.serverId === playerIndex) {
        var scoreServer = match.currentPointPlayer1;
        var scoreOther = match.currentPointPlayer2;
        if (match.flags.serverId === 2) {
          scoreServer = match.currentPointPlayer2;
          scoreOther = match.currentPointPlayer1;
        }
        if (scoreOther === 'A') {
          return 'flagBreak';
        }
        if (scoreOther === '40') {
          if (scoreServer !== '40' && scoreServer !== 'A') {
            return 'flagBreak';
          }
        }
        return 'flagBall';
      }
      return '';
    },
    getCountryFlag: function getCountryFlag(country) {
      if (!country) {
        return '';
      } else {
        return 'static/img/country/' + country.toLowerCase() + '.gif';
      }
    },
    getFace: function getFace(face) {
      if (!face) {
        return 'static/img/player/face/avatar.jpg';
      }
      return 'static/img/player/face/' + face.toLowerCase();
    },
    getCard: function getCard(face) {
      if (face) {
        return '/static/img/player/card/' + face.toLowerCase().replace('png', 'jpg');
      }
    },
    getLogo: function getLogo(logo) {
      if (logo) {
        return 'static/img/sponsor/' + logo;
      }
    },
    getPercentage: function getPercentage(value, total) {
      if (!value || !total) {
        return 0;
      }
      if (value <= 0) {
        return 0;
      }
      if (value >= total) {
        return 100;
      }
      return value * 100 / total;
    },
    extractPercentage: function extractPercentage(value) {
      if (!value) {
        return 0;
      }
      var i = value.indexOf('%');
      if (i <= 0) {
        return value;
      }
      return value.substring(0, i);
    }

  }
});

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"g-bg-attachment-fixed g-bg-white-opacity-0_1"},[_vm._m(0,false,false),_vm._v(" "),_c('section',{staticClass:"js-carousel g-overflow-hidden g-max-height-100vh",attrs:{"id":"live","data-autoplay":"false","data-accessibility":"false","data-pagi-classes":""}},[_c('div',{staticClass:"js-slide"},[_c('div',{staticClass:"g-flex-centered g-height-100vh g-min-height-500--md g-bg-cover g-bg-pos-center g-bg-img-hero"},[(_vm.currentMatch)?_c('div',{staticClass:"container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(_vm.currentMatch.player1.face)}})]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('h2',{staticClass:"text-uppercase g-font-weight-700 g-font-size-default g-font-size-26--md g-font-size-36--lg"},[_vm._v("\n                "+_vm._s(_vm.currentMatch.player1.displayname)),_c('span',[_vm._v(" - ")]),_vm._v(_vm._s(_vm.currentMatch.player2.displayname)+"\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"g-font-weight-500 g-font-size-default g-font-size-22--md g-font-size-32--lg g-mb-20"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.currentMatch.date))+" - "+_vm._s(_vm.currentMatch.round)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(_vm.currentMatch.player2.face)}})])]),_vm._v(" "),_c('div',[(_vm.currentMatch.startDate)?_c('table',{staticClass:"table g-font-weight-500 g-font-size-default g-font-size-24--md g-font-size-32--lg g-mb-10"},[_vm._m(1,false,false),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('img',{staticClass:"g-rounded-10 mx-auto country",attrs:{"src":_vm.getCountryFlag(_vm.currentMatch.player1.country)}})]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.currentMatch.player1.firstname)+" "+_vm._s(_vm.currentMatch.player1.lastname))]),_vm._v(" "),_c('td',[_c('figure',{class:_vm.getFlag(_vm.currentMatch,1)})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[0].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[1].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[2].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.currentPointPlayer1))])]),_vm._v(" "),_c('tr',[_c('td',[_c('img',{staticClass:"g-rounded-10 mx-auto country",attrs:{"src":_vm.getCountryFlag(_vm.currentMatch.player2.country)}})]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.currentMatch.player2.firstname)+" "+_vm._s(_vm.currentMatch.player2.lastname))]),_vm._v(" "),_c('td',[_c('figure',{class:_vm.getFlag(_vm.currentMatch,2)})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[0].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[1].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[2].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.currentPointPlayer2))])]),_vm._v(" "),_c('tr',[_c('td',[_c('a',{staticClass:"btn btn-link",on:{"click":function($event){_vm.showStats(_vm.currentMatch.id)}}},[_c('i',{staticClass:"fa fa-bar-chart",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.getTotalDuration(_vm.currentMatch.startDate, _vm.currentMatch.endDate, _vm.currentMatch.currentDate))+"\n                        ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(_vm.currentMatch.sets[0].startDate, _vm.currentMatch.sets[0].endDate, _vm.currentMatch.currentDate))+"\n                        ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(_vm.currentMatch.sets[1].startDate, _vm.currentMatch.sets[1].endDate, _vm.currentMatch.currentDate))+"\n                        ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(_vm.currentMatch.sets[2].startDate, _vm.currentMatch.sets[2].endDate, _vm.currentMatch.currentDate))+"\n                        ")]),_vm._v(" "),_c('td')])])]):_vm._e()])]):_c('div',{staticClass:"container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15"},[_c('h2',[_vm._v("Coming Soon")])])])])]),_vm._v(" "),(_vm.stats)?_c('section',{staticClass:"g-pb-60",attrs:{"id":"stats"}},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"g-flex-centered g-height-100vh g-min-height-500--md g-bg-cover g-bg-pos-center g-bg-img-hero"},[_c('div',{staticClass:"container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(_vm.stats[0].player.face)}})]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('h2',{staticClass:"g-font-size-default g-font-size-24--md g-font-size-32--lg"},[_vm._v("\n                "+_vm._s(_vm.stats[0].player.displayname)),_c('span',[_vm._v(" - ")]),_vm._v(_vm._s(_vm.stats[1].player.displayname)+"\n              ")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(_vm.stats[1].player.face)}})])]),_vm._v(" "),_c('div',{staticClass:"g-my-10 g-font-size-default g-font-size-18--md g-font-size-26--lg"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                "+_vm._s(_vm.stats[0].ace)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("ACES")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                "+_vm._s(_vm.stats[1].ace)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.stats[0].ace,_vm.stats[0].ace + _vm.stats[1].ace) +'%'}),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.stats[1].ace,_vm.stats[0].ace + _vm.stats[1].ace) +'%'}),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[0].doubleFault)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("DOUBLES FAUTES\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[1].doubleFault)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.stats[0].doubleFault,_vm.stats[0].doubleFault + _vm.stats[1].doubleFault) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.stats[1].doubleFault,_vm.stats[0].doubleFault + _vm.stats[1].doubleFault) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[0].firstServeIn)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("PREMIERS SERVICES\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[1].firstServeIn)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.stats[0].firstServeIn) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.stats[1].firstServeIn) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[0].firstServeWon)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("POINTS GAGNES 1ER SERVICE\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[1].firstServeWon)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.stats[0].firstServeWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.stats[1].firstServeWon) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[0].secondServeWon)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("POINTS GAGNES 2ND SERVICE\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[1].secondServeWon)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.stats[0].secondServeWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.stats[1].secondServeWon) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[0].breakWon)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("BALLES DE BREAK\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[1].breakWon)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.stats[0].breakWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.stats[1].breakWon) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[0].winners)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("POINTS GAGNANTS\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[1].winners)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.stats[0].winners,_vm.stats[0].winners + _vm.stats[1].winners) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.stats[1].winners,_vm.stats[0].winners + _vm.stats[1].winners) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[0].unforcedErrors)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("FAUTES DIRECTES\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[1].unforcedErrors)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.stats[0].unforcedErrors,_vm.stats[0].unforcedErrors + _vm.stats[1].unforcedErrors) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.stats[1].unforcedErrors,_vm.stats[0].unforcedErrors + _vm.stats[1].unforcedErrors) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[0].forcedErrors)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("FAUTES PROVOQUEES\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[1].forcedErrors)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.stats[0].forcedErrors,_vm.stats[0].forcedErrors + _vm.stats[1].forcedErrors) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.stats[1].forcedErrors,_vm.stats[0].forcedErrors + _vm.stats[1].forcedErrors) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[0].totalPointWon)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("TOTAL POINTS GAGNES\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.stats[1].totalPointWon)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.stats[0].totalPointWon,_vm.stats[0].totalPointWon + _vm.stats[1].totalPointWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.stats[1].totalPointWon,_vm.stats[0].totalPointWon + _vm.stats[1].totalPointWon) +'%' }),attrs:{"role":"progressbar"}})])])])])])])])],1):_vm._e(),_vm._v(" "),_c('section',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.reloadMatch),expression:"reloadMatch"}],staticClass:"g-pb-60",attrs:{"id":"results"}},[_c('div',{staticClass:"container"},[_vm._m(2,false,false),_vm._v(" "),(_vm.matchList)?_c('div',{staticClass:"row"},_vm._l((_vm.matchList),function(match){return _c('div',{staticClass:"g-my-5 col-md-6 col-12"},[_c('div',{staticClass:"text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15 g-mb-10"},[_c('div',{staticClass:"row g-pa-10"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(match.player1.face)}})]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('h2',{staticClass:"text-uppercase g-font-weight-700 g-font-size-default"},[_vm._v("\n                  "+_vm._s(match.player1.displayname)),_c('span',[_vm._v(" - ")]),_vm._v(_vm._s(match.player2.displayname)+"\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"g-font-weight-500 g-font-size-default g-mb-10"},[_vm._v(_vm._s(_vm._f("formatDate")(match.date))+" - "+_vm._s(match.round)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(match.player2.face)}})])]),_vm._v(" "),_c('div',{staticClass:"g-mx-5"},[(match.startDate)?_c('table',{staticClass:"table g-font-weight-500 g-font-size-default g-mb-10"},[_vm._m(3,true,false),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('img',{staticClass:"g-rounded-10 mx-auto country",attrs:{"src":_vm.getCountryFlag(match.player1.country)}})]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(match.player1.firstname)+" "+_vm._s(match.player1.lastname))]),_vm._v(" "),_c('td',[_c('figure',{class:_vm.getFlag(match,1)})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(match.sets[0].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(match.sets[1].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(match.sets[2].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(match.currentPointPlayer1))])]),_vm._v(" "),_c('tr',[_c('td',[_c('img',{staticClass:"g-rounded-10 mx-auto country",attrs:{"src":_vm.getCountryFlag(match.player2.country)}})]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(match.player2.firstname)+" "+_vm._s(match.player2.lastname))]),_vm._v(" "),_c('td',[_c('figure',{class:_vm.getFlag(match,2)})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(match.sets[0].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(match.sets[1].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(match.sets[2].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(match.currentPointPlayer2))])]),_vm._v(" "),_c('tr',[_c('td',[_c('a',{staticClass:"btn btn-link",on:{"click":function($event){_vm.showStats(match.id)}}},[_c('i',{staticClass:"fa fa-bar-chart",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.getTotalDuration(match.startDate, match.endDate, _vm.currentMatch.currentDate))+"\n                        ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(match.sets[0].startDate, match.sets[0].endDate, _vm.currentMatch.currentDate))+"\n                        ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(match.sets[1].startDate, match.sets[1].endDate, _vm.currentMatch.currentDate))+"\n                        ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(match.sets[2].startDate, match.sets[2].endDate, _vm.currentMatch.currentDate))+"\n                        ")]),_vm._v(" "),_c('td')])])]):_vm._e()])])])})):_vm._e()])]),_vm._v(" "),_c('section',{staticClass:"g-pb-60",attrs:{"id":"players"}},[_c('div',{staticClass:"container"},[_vm._m(4,false,false),_vm._v(" "),(_vm.playerList)?_c('div',{staticClass:"row"},_vm._l((_vm.playerList),function(player){return _c('div',{staticClass:"col-md-4 col-sm-6 g-mb-10"},[_c('article',{staticClass:"g-bg-black-opacity-0_6 g-rounded-15 text-center g-color-white"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(player.face)}}),_vm._v(" "),_c('div',{staticClass:"g-pa-10"},[_c('h3',{staticClass:"text-uppercase g-font-weight-700 g-font-size-18"},[_vm._v("\n                  "+_vm._s(player.firstname)+" "+_vm._s(player.lastname)+"\n                ")]),_vm._v(" "),_c('h4',{staticClass:"text-uppercase g-font-weight-700 g-font-size-default"},[_vm._v("\n                  "+_vm._s(player.country)+"\n                ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline team-social"},[_c('li',{staticClass:"list-inline-item"},[_c('a',{staticClass:"fb tooltips",attrs:{"data-placement":"top","data-toggle":"tooltip","data-original-title":"Facebook","href":player.facebook,"target":"_blank"}},[_c('i',{staticClass:"fa fa-facebook"})])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('a',{staticClass:"tw tooltips",attrs:{"data-placement":"top","data-toggle":"tooltip","data-original-title":"Twitter","href":player.twitter,"target":"_blank"}},[_c('i',{staticClass:"fa fa-twitter"})])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('a',{staticClass:"gp tooltips",attrs:{"data-placement":"top","data-toggle":"tooltip","data-original-title":"Detail","href":_vm.getCard(player.face),"target":"_blank"}},[_c('i',{staticClass:"fa fa-info"})])])])])])])})):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"u-header u-header--sticky-top u-header--change-appearance",attrs:{"id":"js-header","data-header-fix-moment":"100"}},[_c('div',{staticClass:"u-header__section u-header__section--dark g-bg-black-opacity-0_6 g-transition-0_3 g-py-20",attrs:{"data-header-fix-moment-exclude":"g-bg-black-opacity-0_3 g-py-20","data-header-fix-moment-classes":"g-bg-black-opacity-0_8 g-py-10"}},[_c('nav',{staticClass:"navbar navbar-expand-lg py-0"},[_c('div',{staticClass:"container g-pos-rel"},[_c('a',{staticClass:"js-go-to navbar-brand u-header__logo g-width-130 g-mr-60",attrs:{"href":"/","data-type":"static"}},[_c('img',{staticClass:"img-fluid u-header__logo-img u-header__logo-img--main",attrs:{"src":"/static/img/logoOpen.png","alt":"Image Description"}})]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse w-100",attrs:{"id":"navBar","data-mobile-scroll-hide":"true"}},[_c('div',{staticClass:"navbar-collapse align-items-center flex-sm-row"},[_c('ul',{staticClass:"navbar-nav text-uppercase g-font-weight-700 g-font-size-13 g-py-20 g-py-0--lg",attrs:{"id":"js-scroll-nav"}},[_c('li',{staticClass:"nav-item g-mr-10--lg g-mr-15--xl g-my-7 g-mb-0--lg active"},[_c('a',{staticClass:"nav-link p-0",attrs:{"href":"#live"}},[_vm._v("Live "),_c('span',{staticClass:"sr-only"},[_vm._v("(current)")])])]),_vm._v(" "),_c('li',{staticClass:"nav-item g-mx-10--lg g-mx-15--xl g-my-7 g-mb-0--lg"},[_c('a',{staticClass:"nav-link p-0",attrs:{"href":"#results"}},[_vm._v("Résultats")])]),_vm._v(" "),_c('li',{staticClass:"nav-item g-mx-10--lg g-mx-15--xl g-my-7 g-mb-0--lg"},[_c('a',{staticClass:"nav-link p-0",attrs:{"href":"#players"}},[_vm._v("Joueurs")])]),_vm._v(" "),_c('li',{staticClass:"nav-item g-mx-10--lg g-mx-15--xl g-my-7 g-mb-0--lg"},[_c('a',{staticClass:"nav-link p-0",attrs:{"href":"https://www.facebook.com/OPEN-DE-CAEN-131376730214870/","target":"_blank"}},[_c('i',{staticClass:"fa fa-facebook g-color-facebook"})])]),_vm._v(" "),_c('li',{staticClass:"nav-item g-ml-10--lg g-ml-15--xl g-my-7 g-mb-0--lg"},[_c('a',{staticClass:"nav-link p-0",attrs:{"href":"https://twitter.com/opencaen","target":"_blank"}},[_c('i',{staticClass:"fa fa-twitter g-color-twitter"})])])])])]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler btn g-line-height-1 g-brd-none g-pa-0 g-pos-abs g-top-5 g-right-0",attrs:{"type":"button","aria-label":"Toggle navigation","aria-expanded":"false","aria-controls":"navBar","data-toggle":"collapse","data-target":"#navBar"}},[_c('span',{staticClass:"hamburger hamburger--slider"},[_c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner"})])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("Pts")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15 g-mb-60"},[_c('h2',[_vm._v("Résultats")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("Pts")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15  g-mb-60"},[_c('h2',[_vm._v("Joueurs")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pds_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28bf2312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pds_vue__ = __webpack_require__(142);
function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pds_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28bf2312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pds_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$socket.emit('getCurrentMatch');
  },
  data: function data() {
    return {
      currentMatch: undefined,
      currentPlayer: undefined,
      currentStat: undefined,
      currentTweet: undefined,
      display: 'score'
    };
  },

  sockets: {
    displayMatch: function displayMatch(data) {
      if (data) {
        this.currentMatch = data;
        this.display = 'score';
      }
    },
    displayPlayer: function displayPlayer(data) {
      if (data) {
        console.log('receive player ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        this.currentPlayer = data;
        this.display = 'player';
      }
    },
    displayStat: function displayStat(data) {
      if (data) {
        console.log('receive stats ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        this.currentStat = data;
        this.display = 'stat';
      }
    },
    displayTweet: function displayTweet(data) {
      var _this = this;

      if (data) {
        console.log('receive tweet ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        this.currentTweet = data;
        setTimeout(function () {
          _this.currentTweet = undefined;
        }, 10000);
      }
    }
  },
  methods: {
    getTotalDuration: function getTotalDuration(startDate, endDate, currentDate) {
      if (startDate) {
        var sDate = new Date(startDate);
        var eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date();
        var duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000);
        if (duration < 0) {
          duration = 0;
        }
        var hours = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - hours * 3600) / 60);

        if (minutes < 10) {
          minutes = '0' + minutes;
        }
        return hours + ':' + minutes;
      } else {
        return '0\'';
      }
    },
    getDuration: function getDuration(startDate, endDate, currentDate) {
      if (startDate) {
        var sDate = new Date(startDate);
        var eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date();
        var duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000);
        if (duration < 0) {
          duration = 0;
        }
        var hours = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - hours * 3600) / 60) + hours * 60;

        return minutes + '\'';
      } else {
        return '0\'';
      }
    },
    getFlag: function getFlag(match, playerIndex) {
      if (!match || !match.flags) {
        return '';
      }
      if (match.flags.winnerId === playerIndex) {
        return 'flagWinner';
      } else if (match.flags.serverId === playerIndex) {
        var scoreServer = match.currentPointPlayer1;
        var scoreOther = match.currentPointPlayer2;
        if (match.flags.serverId === 2) {
          scoreServer = match.currentPointPlayer2;
          scoreOther = match.currentPointPlayer1;
        }
        if (scoreOther === 'A') {
          return 'flagBreak';
        }
        if (scoreOther === '40') {
          if (scoreServer !== '40' && scoreServer !== 'A') {
            return 'flagBreak';
          }
        }
        return 'flagBall';
      }
      return '';
    },
    getCountryFlag: function getCountryFlag(country) {
      if (!country) {
        return '';
      } else {
        return 'static/img/country/' + country.toLowerCase() + '.gif';
      }
    },
    getFace: function getFace(face) {
      if (!face) {
        return 'static/img/player/face/avatar.jpg';
      }
      return 'static/img/player/face/' + face.toLowerCase();
    },
    getCard: function getCard(face) {
      if (face) {
        return '/static/img/player/card/' + face.replace('png', 'jpg').toLowerCase();
      }
    },
    getLogo: function getLogo(logo) {
      if (logo) {
        return 'static/img/sponsor/' + logo;
      }
    },
    getPercentage: function getPercentage(value, total) {
      if (!value || !total) {
        return 0;
      }
      if (value <= 0) {
        return 0;
      }
      if (value >= total) {
        return 100;
      }
      return value * 100 / total;
    },
    getStatsTitle: function getStatsTitle(stats) {
      if (!stats) {
        return '';
      }
      if (stats.setIndex >= 0) {
        return 'Set ' + (stats.setIndex + 1);
      }
      return 'Match';
    },
    extractPercentage: function extractPercentage(value) {
      if (!value) {
        return 0;
      }
      var i = value.indexOf('%');
      if (i <= 0) {
        return value;
      }
      return value.substring(0, i);
    }
  }
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"g-bg-attachment-fixed g-overflow-hidden g-bg-black-opacity-0_1"},[_c('section',{staticClass:"js-carousel g-max-height-100vh",attrs:{"id":"score"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.display==='score')?_c('div',{attrs:{"id":"score"}},[_c('div',{staticClass:"g-flex-centered g-height-100vh g-min-height-500--md g-bg-cover g-bg-pos-center g-bg-img-hero"},[(_vm.currentTweet)?_c('div',{staticClass:"m-3 fixed-top text-center g-color-white"},[_c('div',{staticClass:"container g-bg-black-opacity-0_7"},[_c('span',{staticClass:"g-font-size-24--md g-font-size-45--lg"},[_c('i',{staticClass:"fa fa-twitter g-color-twitter"}),_vm._v("\n                "+_vm._s(_vm.currentTweet.author)+" - "+_vm._s(_vm.currentTweet.content)+"\n              ")])])]):_c('div',{staticClass:"m-2 fixed-top container-fluid row mx-auto"},[_c('div',{staticClass:"col-5"}),_vm._v(" "),_c('div',{staticClass:"col-2 text-center g-color-white align-middle"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logoOpen.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"col-5"})]),_vm._v(" "),(_vm.currentMatch)?_c('div',{staticClass:"container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_7"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block",attrs:{"src":_vm.getFace(_vm.currentMatch.player1.face)}})]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('h2',{staticClass:"text-uppercase g-font-weight-700 g-font-size-default g-font-size-26--md g-font-size-50--lg"},[_vm._v("\n                  "+_vm._s(_vm.currentMatch.player1.displayname)),_c('span',[_vm._v(" - ")]),_vm._v(_vm._s(_vm.currentMatch.player2.displayname)+"\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"g-font-weight-500 g-font-size-default g-font-size-22--md g-font-size-40--lg g-mb-20"},[_vm._v("\n                  "+_vm._s(_vm._f("formatDate")(_vm.currentMatch.date))+" - "+_vm._s(_vm.currentMatch.round)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block",attrs:{"src":_vm.getFace(_vm.currentMatch.player2.face)}})])]),_vm._v(" "),_c('div',[(_vm.currentMatch.startDate)?_c('table',{staticClass:"table g-font-weight-500 g-font-size-default g-font-size-24--md g-font-size-50--lg g-mb-10"},[_c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("Pts")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('img',{staticClass:"mx-auto country",attrs:{"src":_vm.getCountryFlag(_vm.currentMatch.player1.country)}})]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.currentMatch.player1.firstname)+" "+_vm._s(_vm.currentMatch.player1.lastname))]),_vm._v(" "),_c('td',[_c('figure',{class:_vm.getFlag(_vm.currentMatch,1)})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[0].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[1].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[2].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.currentPointPlayer1))])]),_vm._v(" "),_c('tr',[_c('td',[_c('img',{staticClass:"mx-auto country",attrs:{"src":_vm.getCountryFlag(_vm.currentMatch.player2.country)}})]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.currentMatch.player2.firstname)+" "+_vm._s(_vm.currentMatch.player2.lastname))]),_vm._v(" "),_c('td',[_c('figure',{class:_vm.getFlag(_vm.currentMatch,2)})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[0].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[1].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[2].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.currentPointPlayer2))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.getTotalDuration(_vm.currentMatch.startDate, _vm.currentMatch.endDate,
                    _vm.currentMatch.currentDate))+"\n                  ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(_vm.currentMatch.sets[0].startDate, _vm.currentMatch.sets[0].endDate,
                    _vm.currentMatch.currentDate))+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(_vm.currentMatch.sets[1].startDate, _vm.currentMatch.sets[1].endDate,
                    _vm.currentMatch.currentDate))+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(_vm.currentMatch.sets[2].startDate, _vm.currentMatch.sets[2].endDate,
                    _vm.currentMatch.currentDate))+"\n                  ")]),_vm._v(" "),_c('td')])])]):_vm._e()])]):_c('div',{staticClass:"container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_7"},[_c('h2',[_vm._v("Coming Soon")])]),_vm._v(" "),_c('div',{staticClass:"fixed-bottom container-fluid row mx-auto g-bg-black"},[_c('div',{staticClass:"col-2 m-auto"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/sponsor/jurzak2.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"col-2 m-auto"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/sponsor/leclerc-fit.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"col-2 m-auto"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/sponsor/verspieren-3.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"col-2 m-auto"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/sponsor/villa-eugene.png","alt":"Logo"}})])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.display==='stat')?_c('div',{attrs:{"id":"stat"}},[_c('div',{staticClass:"g-flex-centered g-height-100vh g-min-height-500--md g-bg-cover g-bg-pos-center g-bg-img-hero"},[_c('div',{staticClass:"container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_7"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block",attrs:{"src":_vm.getFace(_vm.currentStat[0].player.face)}})]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('h2',{staticClass:"g-font-size-default g-font-size-26--md g-font-size-50--lg"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].player.displayname)),_c('span',[_vm._v(" - ")]),_vm._v(_vm._s(_vm.currentStat[1].player.displayname)+"\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',{staticClass:"g-font-size-default g-font-size-26--md g-font-size-50--lg"},[_vm._v("\n                  "+_vm._s(_vm.getStatsTitle(_vm.currentStat[0]))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block",attrs:{"src":_vm.getFace(_vm.currentStat[1].player.face)}})])]),_vm._v(" "),_c('div',{staticClass:"g-my-10 g-font-size-default g-font-size-20--md g-font-size-36--lg"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].ace)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("ACES")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].ace)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].ace,_vm.currentStat[0].ace + _vm.currentStat[1].ace) +'%'}),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].ace,_vm.currentStat[0].ace + _vm.currentStat[1].ace) +'%'}),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].doubleFault)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("DOUBLES FAUTES\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].doubleFault)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].doubleFault,_vm.currentStat[0].doubleFault + _vm.currentStat[1].doubleFault) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].doubleFault,_vm.currentStat[0].doubleFault + _vm.currentStat[1].doubleFault) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].firstServeIn)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("1ER SERVICE\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].firstServeIn)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.currentStat[0].firstServeIn) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.currentStat[1].firstServeIn) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].firstServeWon)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("POINTS GAGNES 1ER SERVICE\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].firstServeWon)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.currentStat[0].firstServeWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.currentStat[1].firstServeWon) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].secondServeWon)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("POINTS GAGNES 2ND SERVICE\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].secondServeWon)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.currentStat[0].secondServeWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.currentStat[1].secondServeWon) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].breakWon)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("BALLES DE BREAK\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].breakWon)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.currentStat[0].breakWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.currentStat[1].breakWon) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].winners)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("POINTS GAGNANTS\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].winners)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].winners,_vm.currentStat[0].winners + _vm.currentStat[1].winners) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].winners,_vm.currentStat[0].winners + _vm.currentStat[1].winners) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].unforcedErrors)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("FAUTES DIRECTES\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].unforcedErrors)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].unforcedErrors,_vm.currentStat[0].unforcedErrors + _vm.currentStat[1].unforcedErrors) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].unforcedErrors,_vm.currentStat[0].unforcedErrors + _vm.currentStat[1].unforcedErrors) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].forcedErrors)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("FAUTES PROVOQUEES\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].forcedErrors)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].forcedErrors,_vm.currentStat[0].forcedErrors + _vm.currentStat[1].forcedErrors) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].forcedErrors,_vm.currentStat[0].forcedErrors + _vm.currentStat[1].forcedErrors) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].totalPointWon)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("TOTAL POINTS GAGNES\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].totalPointWon)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].totalPointWon,_vm.currentStat[0].totalPointWon + _vm.currentStat[1].totalPointWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].totalPointWon,_vm.currentStat[0].totalPointWon + _vm.currentStat[1].totalPointWon) +'%' }),attrs:{"role":"progressbar"}})])])])])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.display==='player')?_c('div',{attrs:{"id":"player"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.getCard(_vm.currentPlayer.face)}})]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Live_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a6c1e1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Live_vue__ = __webpack_require__(146);
function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Live_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a6c1e1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Live_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$socket.emit('getCurrentMatch');
  },
  data: function data() {
    return {
      currentMatch: undefined,
      currentPlayer: undefined,
      currentStat: undefined,
      currentTweet: undefined,
      display: 'score'
    };
  },

  sockets: {
    connection: function connection() {
      console.log('socket connection');
    },
    connect: function connect() {
      console.log('socket connected');
    },
    disconnect: function disconnect() {
      console.log('socket disconnected');
    },
    displayMatch: function displayMatch(data) {
      if (data) {
        this.currentMatch = data;
        this.display = 'score';
      }
    }
  },
  methods: {
    getTotalDuration: function getTotalDuration(startDate, endDate, currentDate) {
      if (startDate) {
        var sDate = new Date(startDate);
        var eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date();
        var duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000);
        if (duration < 0) {
          duration = 0;
        }
        var hours = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - hours * 3600) / 60);

        if (minutes < 10) {
          minutes = '0' + minutes;
        }
        return hours + ':' + minutes;
      } else {
        return '0\'';
      }
    },
    getDuration: function getDuration(startDate, endDate, currentDate) {
      if (startDate) {
        var sDate = new Date(startDate);
        var eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date();
        var duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000);
        if (duration < 0) {
          duration = 0;
        }
        var hours = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - hours * 3600) / 60) + hours * 60;

        return minutes + '\'';
      } else {
        return '0\'';
      }
    },
    getFlag: function getFlag(match, playerIndex) {
      if (!match || !match.flags) {
        return '';
      }
      if (match.flags.winnerId === playerIndex) {
        return 'flagWinner';
      } else if (match.flags.serverId === playerIndex) {
        var scoreServer = match.currentPointPlayer1;
        var scoreOther = match.currentPointPlayer2;
        if (match.flags.serverId === 2) {
          scoreServer = match.currentPointPlayer2;
          scoreOther = match.currentPointPlayer1;
        }
        if (scoreOther === 'A') {
          return 'flagBreak';
        }
        if (scoreOther === '40') {
          if (scoreServer !== '40' && scoreServer !== 'A') {
            return 'flagBreak';
          }
        }
        return 'flagBall';
      }
      return '';
    },
    getCountryFlag: function getCountryFlag(country) {
      if (!country) {
        return '';
      } else {
        return 'static/img/country/' + country.toLowerCase() + '.gif';
      }
    },
    getFace: function getFace(face) {
      if (!face) {
        return 'static/img/player/face/avatar.jpg';
      }
      return 'static/img/player/face/' + face;
    },
    getCard: function getCard(face) {
      if (face) {
        return '/static/img/player/card/' + face.replace('png', 'jpg').toLowerCase();
      }
    },
    getLogo: function getLogo(logo) {
      if (logo) {
        return 'static/img/sponsor/' + logo;
      }
    },
    getPercentage: function getPercentage(value, total) {
      if (!value || !total) {
        return 0;
      }
      if (value <= 0) {
        return 0;
      }
      if (value >= total) {
        return 100;
      }
      return value * 100 / total;
    },
    extractPercentage: function extractPercentage(value) {
      if (!value) {
        return 0;
      }
      var i = value.indexOf('%');
      if (i <= 0) {
        return value;
      }
      return value.substring(0, i);
    }
  }
});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"g-bg-transparent-fixed g-overflow-hidden"},[_c('section',{staticClass:"js-carousel g-max-height-100vh",attrs:{"id":"score"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.currentMatch)?_c('div',{attrs:{"id":"score"}},[_c('div',{staticClass:"g-height-50vh g-min-height-500--md"},[_c('div',{staticClass:"top-left g-ma-20 text-center g-color-white g-z-index-1"},[_c('table',{staticClass:"table g-font-weight-500 g-font-size-default g-font-size-10--md g-font-size-20"},[_c('tbody',[_c('tr',[_c('th',{staticClass:"text-left g-bg-black-opacity-0_7"},[_vm._v(_vm._s(_vm.currentMatch.player1.lastname)+"\n                    "),_c('figure',{class:_vm.getFlag(_vm.currentMatch,1)})]),_vm._v(" "),(_vm.currentMatch.startDate)?_c('td',{staticClass:"g-bg-black-opacity-0_7"},[_vm._v(_vm._s(_vm.currentMatch.sets[0].scorePlayer1))]):_vm._e(),_vm._v(" "),(_vm.currentMatch.startDate)?_c('td',{staticClass:"g-bg-black-opacity-0_7"},[_vm._v(_vm._s(_vm.currentMatch.sets[1].scorePlayer1))]):_vm._e(),_vm._v(" "),(_vm.currentMatch.startDate)?_c('td',{staticClass:"g-bg-black-opacity-0_7"},[_vm._v(_vm._s(_vm.currentMatch.sets[2].scorePlayer1))]):_vm._e(),_vm._v(" "),(_vm.currentMatch.startDate)?_c('td',{staticClass:"g-bg-black-opacity-0_5"},[_vm._v(_vm._s(_vm.currentMatch.currentPointPlayer1))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-left g-bg-black-opacity-0_7"},[_vm._v(_vm._s(_vm.currentMatch.player2.lastname)+"\n                    "),_c('figure',{class:_vm.getFlag(_vm.currentMatch,2)})]),_vm._v(" "),(_vm.currentMatch.startDate)?_c('td',{staticClass:"g-bg-black-opacity-0_7"},[_vm._v(_vm._s(_vm.currentMatch.sets[0].scorePlayer2))]):_vm._e(),_vm._v(" "),(_vm.currentMatch.startDate)?_c('td',{staticClass:"g-bg-black-opacity-0_7"},[_vm._v(_vm._s(_vm.currentMatch.sets[1].scorePlayer2))]):_vm._e(),_vm._v(" "),(_vm.currentMatch.startDate)?_c('td',{staticClass:"g-bg-black-opacity-0_7"},[_vm._v(_vm._s(_vm.currentMatch.sets[2].scorePlayer2))]):_vm._e(),_vm._v(" "),(_vm.currentMatch.startDate)?_c('td',{staticClass:"g-bg-black-opacity-0_5"},[_vm._v(_vm._s(_vm.currentMatch.currentPointPlayer2))]):_vm._e()])])])])])]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Zenith_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b6872cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Zenith_vue__ = __webpack_require__(150);
function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Zenith_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b6872cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Zenith_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 148:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentMatch: undefined,
      currentPlayer: undefined,
      currentStat: undefined,
      currentTweet: undefined,
      display: 'score'
    };
  },

  sockets: {
    displayMatch: function displayMatch(data) {
      if (data) {
        this.currentMatch = data;
        this.display = 'score';
      }
    },
    displayPlayer: function displayPlayer(data) {
      if (data) {
        console.log('receive player ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        this.currentPlayer = data;
        this.display = 'player';
      }
    },
    displayStat: function displayStat(data) {
      if (data) {
        console.log('receive stats ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        this.currentStat = data;
        this.display = 'stat';
      }
    },
    displayTweet: function displayTweet(data) {
      var _this = this;

      if (data) {
        console.log('receive tweet ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        this.currentTweet = data;
        setTimeout(function () {
          _this.currentTweet = undefined;
        }, 10000);
      }
    }
  },
  methods: {
    getTotalDuration: function getTotalDuration(startDate, endDate, currentDate) {
      if (startDate) {
        var sDate = new Date(startDate);
        var eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date();
        var duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000);
        if (duration < 0) {
          duration = 0;
        }
        var hours = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - hours * 3600) / 60);

        if (minutes < 10) {
          minutes = '0' + minutes;
        }
        return hours + ':' + minutes;
      } else {
        return '0\'';
      }
    },
    getDuration: function getDuration(startDate, endDate, currentDate) {
      if (startDate) {
        var sDate = new Date(startDate);
        var eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date();
        var duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000);
        if (duration < 0) {
          duration = 0;
        }
        var hours = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - hours * 3600) / 60) + hours * 60;

        return minutes + '\'';
      } else {
        return '0\'';
      }
    },
    getFlag: function getFlag(match, playerIndex) {
      if (!match || !match.flags) {
        return '';
      }
      if (match.flags.winnerId === playerIndex) {
        return 'flagWinner';
      } else if (match.flags.serverId === playerIndex) {
        var scoreServer = match.currentPointPlayer1;
        var scoreOther = match.currentPointPlayer2;
        if (match.flags.serverId === 2) {
          scoreServer = match.currentPointPlayer2;
          scoreOther = match.currentPointPlayer1;
        }
        if (scoreOther === 'A') {
          return 'flagBreak';
        }
        if (scoreOther === '40') {
          if (scoreServer !== '40' && scoreServer !== 'A') {
            return 'flagBreak';
          }
        }
        return 'flagBall';
      }
      return '';
    },
    getCountryFlag: function getCountryFlag(country) {
      if (!country) {
        return '';
      } else {
        return 'static/img/country/' + country.toLowerCase() + '.gif';
      }
    },
    getFace: function getFace(face) {
      if (!face) {
        return 'static/img/player/face/avatar.jpg';
      }
      return 'static/img/player/face/' + face;
    },
    getCard: function getCard(face) {
      if (face) {
        return '/static/img/player/card/' + face.replace('png', 'jpg').toLowerCase();
      }
    },
    getLogo: function getLogo(logo) {
      if (logo) {
        return 'static/img/sponsor/' + logo;
      }
    },
    getPercentage: function getPercentage(value, total) {
      if (!value || !total) {
        return 0;
      }
      if (value <= 0) {
        return 0;
      }
      if (value >= total) {
        return 100;
      }
      return value * 100 / total;
    },
    extractPercentage: function extractPercentage(value) {
      if (!value) {
        return 0;
      }
      var i = value.indexOf('%');
      if (i <= 0) {
        return value;
      }
      return value.substring(0, i);
    }
  }
});

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"g-bg-attachment-fixed g-bg-black-opacity-0_1"},[_c('section',{staticClass:"js-carousel g-overflow-hidden g-max-height-100vh",attrs:{"id":"score"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.display==='score')?_c('div',{attrs:{"id":"score"}},[_c('div',{staticClass:"g-flex-centered g-height-100vh g-min-height-500--md g-bg-cover g-bg-pos-center g-bg-img-hero"},[(_vm.currentTweet)?_c('div',{staticClass:"m-3 fixed-top text-center g-color-white"},[_c('div',{staticClass:"container g-bg-black-opacity-0_5 g-rounded-5"},[_c('span',{staticClass:"g-font-size-24--md g-font-size-45--lg"},[_c('i',{staticClass:"fa fa-twitter g-color-twitter"}),_vm._v("\n                "+_vm._s(_vm.currentTweet.author)+" - "+_vm._s(_vm.currentTweet.content)+"\n              ")])])]):_c('div',{staticClass:"m-2 fixed-top container-fluid row mx-auto"},[_c('div',{staticClass:"col-4"}),_vm._v(" "),_c('div',{staticClass:"col-4 text-center g-color-white align-middle"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/OpenBlancRose.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"col-4"})]),_vm._v(" "),(_vm.currentMatch)?_c('div',{staticClass:"container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_5 g-rounded-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(_vm.currentMatch.player1.face)}})]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('h2',{staticClass:"text-uppercase g-font-weight-700 g-font-size-default g-font-size-26--md g-font-size-50--lg"},[_vm._v("\n                  "+_vm._s(_vm.currentMatch.player1.displayname)),_c('span',[_vm._v(" - ")]),_vm._v(_vm._s(_vm.currentMatch.player2.displayname)+"\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"g-font-weight-500 g-font-size-default g-font-size-22--md g-font-size-40--lg g-mb-20"},[_vm._v("\n                  "+_vm._s(_vm._f("formatDate")(_vm.currentMatch.date))+" - "+_vm._s(_vm.currentMatch.round)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(_vm.currentMatch.player2.face)}})])]),_vm._v(" "),_c('div',[(_vm.currentMatch.startDate)?_c('table',{staticClass:"table g-font-weight-500 g-font-size-default g-font-size-24--md g-font-size-50--lg g-mb-10"},[_c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("Pts")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('img',{staticClass:"g-rounded-10 mx-auto country",attrs:{"src":_vm.getCountryFlag(_vm.currentMatch.player1.country)}})]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.currentMatch.player1.firstname)+" "+_vm._s(_vm.currentMatch.player1.lastname))]),_vm._v(" "),_c('td',[_c('figure',{class:_vm.getFlag(_vm.currentMatch,1)})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[0].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[1].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[2].scorePlayer1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.currentPointPlayer1))])]),_vm._v(" "),_c('tr',[_c('td',[_c('img',{staticClass:"g-rounded-10 mx-auto country",attrs:{"src":_vm.getCountryFlag(_vm.currentMatch.player2.country)}})]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.currentMatch.player2.firstname)+" "+_vm._s(_vm.currentMatch.player2.lastname))]),_vm._v(" "),_c('td',[_c('figure',{class:_vm.getFlag(_vm.currentMatch,2)})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[0].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[1].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.sets[2].scorePlayer2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.currentMatch.currentPointPlayer2))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.getTotalDuration(_vm.currentMatch.startDate, _vm.currentMatch.endDate,
                    _vm.currentMatch.currentDate))+"\n                  ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(_vm.currentMatch.sets[0].startDate, _vm.currentMatch.sets[0].endDate,
                    _vm.currentMatch.currentDate))+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(_vm.currentMatch.sets[1].startDate, _vm.currentMatch.sets[1].endDate,
                    _vm.currentMatch.currentDate))+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.getDuration(_vm.currentMatch.sets[2].startDate, _vm.currentMatch.sets[2].endDate,
                    _vm.currentMatch.currentDate))+"\n                  ")]),_vm._v(" "),_c('td')])])]):_vm._e()])]):_c('div',{staticClass:"container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15"},[_c('h2',[_vm._v("Coming Soon")])]),_vm._v(" "),_c('div',{staticClass:"fixed-bottom container-fluid row mx-auto g-bg-black-opacity-0_3"},[_c('div',{staticClass:"col-1 m-auto"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/sponsor/crocus.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"col-2 m-auto"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/sponsor/jurzak2.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"col-2 m-auto"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/sponsor/leclerc-fit.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"col-2 m-auto"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/sponsor/verspieren-3.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"col-2 m-auto"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/sponsor/legallais-fit.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"col-1 m-auto"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/sponsor/villaeugene2.png","alt":"Logo"}})])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.display==='stat')?_c('div',{attrs:{"id":"stat"}},[_c('div',{staticClass:"g-flex-centered g-height-100vh g-min-height-500--md g-bg-cover g-bg-pos-center g-bg-img-hero"},[_c('div',{staticClass:"container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_4 g-rounded-15"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(_vm.currentStat[0].player.face)}})]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('h2',{staticClass:"g-font-size-default g-font-size-26--md g-font-size-50--lg"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].player.displayname)),_c('span',[_vm._v(" - ")]),_vm._v(_vm._s(_vm.currentStat[1].player.displayname)+"\n                ")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid mx-auto d-block g-rounded-20",attrs:{"src":_vm.getFace(_vm.currentStat[1].player.face)}})])]),_vm._v(" "),_c('div',{staticClass:"g-my-10 g-font-size-default g-font-size-20--md g-font-size-36--lg"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].ace)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("ACES")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].ace)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].ace,_vm.currentStat[0].ace + _vm.currentStat[1].ace) +'%'}),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].ace,_vm.currentStat[0].ace + _vm.currentStat[1].ace) +'%'}),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].doubleFault)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("DOUBLES FAUTES\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].doubleFault)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].doubleFault,_vm.currentStat[0].doubleFault + _vm.currentStat[1].doubleFault) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].doubleFault,_vm.currentStat[0].doubleFault + _vm.currentStat[1].doubleFault) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].firstServeIn)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("PREMIERS SERVICES\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].firstServeIn)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.currentStat[0].firstServeIn) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.currentStat[1].firstServeIn) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].firstServeWon)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("POINTS GAGNES 1ER SERVICE\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].firstServeWon)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.currentStat[0].firstServeWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.currentStat[1].firstServeWon) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].secondServeWon)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("POINTS GAGNES 2ND SERVICE\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].secondServeWon)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.currentStat[0].secondServeWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.currentStat[1].secondServeWon) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].breakWon)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("BALLES DE BREAK\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].breakWon)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.extractPercentage(_vm.currentStat[0].breakWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.extractPercentage(_vm.currentStat[1].breakWon) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].winners)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("POINTS GAGNANTS\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].winners)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].winners,_vm.currentStat[0].winners + _vm.currentStat[1].winners) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].winners,_vm.currentStat[0].winners + _vm.currentStat[1].winners) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].unforcedErrors)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("FAUTES DIRECTES\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].unforcedErrors)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].unforcedErrors,_vm.currentStat[0].unforcedErrors + _vm.currentStat[1].unforcedErrors) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].unforcedErrors,_vm.currentStat[0].unforcedErrors + _vm.currentStat[1].unforcedErrors) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].forcedErrors)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("FAUTES PROVOQUEES\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].forcedErrors)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].forcedErrors,_vm.currentStat[0].forcedErrors + _vm.currentStat[1].forcedErrors) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].forcedErrors,_vm.currentStat[0].forcedErrors + _vm.currentStat[1].forcedErrors) +'%' }),attrs:{"role":"progressbar"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[0].totalPointWon)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_vm._v("TOTAL POINTS GAGNES\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_vm._v("\n                  "+_vm._s(_vm.currentStat[1].totalPointWon)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-reverse",style:({ width: _vm.getPercentage(_vm.currentStat[0].totalPointWon,_vm.currentStat[0].totalPointWon + _vm.currentStat[1].totalPointWon) +'%' }),attrs:{"role":"progressbar"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.getPercentage(_vm.currentStat[1].totalPointWon,_vm.currentStat[0].totalPointWon + _vm.currentStat[1].totalPointWon) +'%' }),attrs:{"role":"progressbar"}})])])])])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.display==='player')?_c('div',{attrs:{"id":"player"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.getCard(_vm.currentPlayer.face)}})]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 5,
	"./af.js": 5,
	"./ar": 6,
	"./ar-dz": 7,
	"./ar-dz.js": 7,
	"./ar-kw": 8,
	"./ar-kw.js": 8,
	"./ar-ly": 9,
	"./ar-ly.js": 9,
	"./ar-ma": 10,
	"./ar-ma.js": 10,
	"./ar-sa": 11,
	"./ar-sa.js": 11,
	"./ar-tn": 12,
	"./ar-tn.js": 12,
	"./ar.js": 6,
	"./az": 13,
	"./az.js": 13,
	"./be": 14,
	"./be.js": 14,
	"./bg": 15,
	"./bg.js": 15,
	"./bm": 16,
	"./bm.js": 16,
	"./bn": 17,
	"./bn.js": 17,
	"./bo": 18,
	"./bo.js": 18,
	"./br": 19,
	"./br.js": 19,
	"./bs": 20,
	"./bs.js": 20,
	"./ca": 21,
	"./ca.js": 21,
	"./cs": 22,
	"./cs.js": 22,
	"./cv": 23,
	"./cv.js": 23,
	"./cy": 24,
	"./cy.js": 24,
	"./da": 25,
	"./da.js": 25,
	"./de": 26,
	"./de-at": 27,
	"./de-at.js": 27,
	"./de-ch": 28,
	"./de-ch.js": 28,
	"./de.js": 26,
	"./dv": 29,
	"./dv.js": 29,
	"./el": 30,
	"./el.js": 30,
	"./en-au": 31,
	"./en-au.js": 31,
	"./en-ca": 32,
	"./en-ca.js": 32,
	"./en-gb": 33,
	"./en-gb.js": 33,
	"./en-ie": 34,
	"./en-ie.js": 34,
	"./en-nz": 35,
	"./en-nz.js": 35,
	"./eo": 36,
	"./eo.js": 36,
	"./es": 37,
	"./es-do": 38,
	"./es-do.js": 38,
	"./es-us": 39,
	"./es-us.js": 39,
	"./es.js": 37,
	"./et": 40,
	"./et.js": 40,
	"./eu": 41,
	"./eu.js": 41,
	"./fa": 42,
	"./fa.js": 42,
	"./fi": 43,
	"./fi.js": 43,
	"./fo": 44,
	"./fo.js": 44,
	"./fr": 45,
	"./fr-ca": 46,
	"./fr-ca.js": 46,
	"./fr-ch": 47,
	"./fr-ch.js": 47,
	"./fr.js": 45,
	"./fy": 48,
	"./fy.js": 48,
	"./gd": 49,
	"./gd.js": 49,
	"./gl": 50,
	"./gl.js": 50,
	"./gom-latn": 51,
	"./gom-latn.js": 51,
	"./gu": 52,
	"./gu.js": 52,
	"./he": 53,
	"./he.js": 53,
	"./hi": 54,
	"./hi.js": 54,
	"./hr": 55,
	"./hr.js": 55,
	"./hu": 56,
	"./hu.js": 56,
	"./hy-am": 57,
	"./hy-am.js": 57,
	"./id": 58,
	"./id.js": 58,
	"./is": 59,
	"./is.js": 59,
	"./it": 60,
	"./it.js": 60,
	"./ja": 61,
	"./ja.js": 61,
	"./jv": 62,
	"./jv.js": 62,
	"./ka": 63,
	"./ka.js": 63,
	"./kk": 64,
	"./kk.js": 64,
	"./km": 65,
	"./km.js": 65,
	"./kn": 66,
	"./kn.js": 66,
	"./ko": 67,
	"./ko.js": 67,
	"./ky": 68,
	"./ky.js": 68,
	"./lb": 69,
	"./lb.js": 69,
	"./lo": 70,
	"./lo.js": 70,
	"./lt": 71,
	"./lt.js": 71,
	"./lv": 72,
	"./lv.js": 72,
	"./me": 73,
	"./me.js": 73,
	"./mi": 74,
	"./mi.js": 74,
	"./mk": 75,
	"./mk.js": 75,
	"./ml": 76,
	"./ml.js": 76,
	"./mr": 77,
	"./mr.js": 77,
	"./ms": 78,
	"./ms-my": 79,
	"./ms-my.js": 79,
	"./ms.js": 78,
	"./my": 80,
	"./my.js": 80,
	"./nb": 81,
	"./nb.js": 81,
	"./ne": 82,
	"./ne.js": 82,
	"./nl": 83,
	"./nl-be": 84,
	"./nl-be.js": 84,
	"./nl.js": 83,
	"./nn": 85,
	"./nn.js": 85,
	"./pa-in": 86,
	"./pa-in.js": 86,
	"./pl": 87,
	"./pl.js": 87,
	"./pt": 88,
	"./pt-br": 89,
	"./pt-br.js": 89,
	"./pt.js": 88,
	"./ro": 90,
	"./ro.js": 90,
	"./ru": 91,
	"./ru.js": 91,
	"./sd": 92,
	"./sd.js": 92,
	"./se": 93,
	"./se.js": 93,
	"./si": 94,
	"./si.js": 94,
	"./sk": 95,
	"./sk.js": 95,
	"./sl": 96,
	"./sl.js": 96,
	"./sq": 97,
	"./sq.js": 97,
	"./sr": 98,
	"./sr-cyrl": 99,
	"./sr-cyrl.js": 99,
	"./sr.js": 98,
	"./ss": 100,
	"./ss.js": 100,
	"./sv": 101,
	"./sv.js": 101,
	"./sw": 102,
	"./sw.js": 102,
	"./ta": 103,
	"./ta.js": 103,
	"./te": 104,
	"./te.js": 104,
	"./tet": 105,
	"./tet.js": 105,
	"./th": 106,
	"./th.js": 106,
	"./tl-ph": 107,
	"./tl-ph.js": 107,
	"./tlh": 108,
	"./tlh.js": 108,
	"./tr": 109,
	"./tr.js": 109,
	"./tzl": 110,
	"./tzl.js": 110,
	"./tzm": 111,
	"./tzm-latn": 112,
	"./tzm-latn.js": 112,
	"./tzm.js": 111,
	"./uk": 113,
	"./uk.js": 113,
	"./ur": 114,
	"./ur.js": 114,
	"./uz": 115,
	"./uz-latn": 116,
	"./uz-latn.js": 116,
	"./uz.js": 115,
	"./vi": 117,
	"./vi.js": 117,
	"./x-pseudo": 118,
	"./x-pseudo.js": 118,
	"./yo": 119,
	"./yo.js": 119,
	"./zh-cn": 120,
	"./zh-cn.js": 120,
	"./zh-hk": 121,
	"./zh-hk.js": 121,
	"./zh-tw": 122,
	"./zh-tw.js": 122
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;

/***/ })

},[123]);


// WEBPACK FOOTER //
// static/js/app.715640a8573f48d2fc84.js